import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./style/main.css"
import "./style/flex.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.use(ElementUI)

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 添加认证header
    config.headers.USERNAME = store.getters.getUsername
    config.headers.TIMESTAMP = store.getters.getTimestamp
    config.headers.TOKEN = store.getters.getToken
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 在 main.js 中添加
// 保存原始的 fetch 函数
const originalFetch = window.fetch;

// 重写 fetch 函数
window.fetch = function(url, options = {}) {
  // 确保 options 对象存在
  options = options || {};
  
  // 确保 headers 对象存在
  options.headers = options.headers || {};
  
  // 添加认证 header
  options.headers.USERNAME = store.getters.getUsername;
  options.headers.TIMESTAMP = store.getters.getTimestamp;
  options.headers.TOKEN = store.getters.getToken;
  
  // 调用原始的 fetch 函数
  return originalFetch.call(this, url, options);
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')



